import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api.algomasters.in/",
  timeout: 15000,
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("Access-Token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});


// Handle responses globally
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      // 🔴 Logout logic
      localStorage.removeItem("Access-Token");
      localStorage.removeItem("User-Role");
      localStorage.removeItem("User-Id");
      // redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default API;
